import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { SpecialUser } from '../../@types';

type Payload = {
  specialUsers: SpecialUser[];
};

const addSpecialUserByAdmin = async (payload: Payload): Promise<void> => {
  const res = await axiosInstance.post('/api/users/special-user', payload);
  return res.data;
};

export const useAddSpecialUserByAdmin = () => {
  return useMutation(addSpecialUserByAdmin, { onSuccess: (data) => data });
};
